import { render, staticRenderFns } from "./recommended_list.vue?vue&type=template&id=0ec9a158&scoped=true"
import script from "./recommended_list.vue?vue&type=script&lang=js"
export * from "./recommended_list.vue?vue&type=script&lang=js"
import style0 from "./recommended_list.vue?vue&type=style&index=0&id=0ec9a158&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ec9a158",
  null
  
)

export default component.exports